import { render, staticRenderFns } from "./BInput.vue?vue&type=template&id=b538ca92&scoped=true"
import script from "./BInput.vue?vue&type=script&lang=js"
export * from "./BInput.vue?vue&type=script&lang=js"
import style0 from "./BInput.vue?vue&type=style&index=0&id=b538ca92&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b538ca92",
  null
  
)

export default component.exports